import axios from '@/axios/axios-api'
import clientCode from '@/helpers/getClientCode'

const actions = {
  async getProducts (context, params) {
    const code = clientCode()
    const response = await axios.get(`/api/productos/${code}/${params}`)
    const data = (Array.isArray(response.data) ? response.data : [])
      .filter(p => Number(p.precio) > 0 || Number(p.PrecioUnitario) > 0)
    data.forEach((producto) => {
      producto.cant = 1
    })
    context.commit('setProducts', data)
  },
  async getProductById (context, params) {
    const response = await axios.get(`/api/producto/${params}`)
    response.data.cant = 1
    return response.data
  },
  async fetchProducts (context, params) {
    const code = clientCode()
    const response = await axios.get(`/api/productos/${code}/${params}`)
    const data = Array.isArray(response.data) ? response.data : []
    return data.filter(p => Number(p.precio) > 0 || Number(p.PrecioUnitario) > 0)
  },
  async getProductsByCatId (context, params) {
    const response = await axios.get(`/api/productos/${params.catId}?productoId=${params.prodId}`)
    const data = Array.isArray(response.data) ? response.data : []
    return data.filter(p => {
      p.cant = 1
      return Number(p.precio) > 0 || Number(p.PrecioUnitario) > 0
    })
  }
}

export default actions
